<template slot-scope="scope">
  <div v-if="isOverLimit" class="redeem-button-wrapper over-limit">
    {{ $t('common.overLimit') }}
  </div>
  <div v-else-if="isRedeemable" class="redeem-button-wrapper">
    <el-button class="el-button blue_button" @click="onClickRedeem">
      <span>{{ $t('promotion.referFriends.redeemButtonRedeem') }}</span>
    </el-button>
  </div>
  <div v-else-if="isAllRedeemed">
    {{ $t('promotion.referFriends.redeemButtonRedeemed') }}
  </div>
  <div v-else-if="isDisabledButton" class="redeem-button-wrapper">
    <el-button class="el-button blue_button" disabled>
      <span>{{ $t('promotion.referFriends.redeemButtonRedeem') }}</span>
    </el-button>
  </div>
  <div v-else-if="isHideRedeemButton"></div>
  <div v-else-if="isExpired">
    {{ $t('promotion.referFriends.redeemButtonExpired') }}
  </div>
  <div v-else-if="isRejected">
    {{ $t('promotion.referFriends.redeemButtonRejected') }}
  </div>
  <div v-else class="redeem-button-wrapper">
    <el-button class="el-button blue_button" disabled>
      <span>{{ $t('promotion.referFriends.redeemButtonRedeem') }}</span>
    </el-button>
  </div>
</template>

<script>
export default {
  name: 'Redeem',
  props: {
    isOverLimit: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isAllRedeemed: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isRedeemable: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isDisabledButton: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isHideRedeemButton: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isRejected: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    isExpired: {
      type: Boolean,
      default: () => {
        return false;
      }
    }
  },
  methods: {
    onClickRedeem() {
      this.$emit('click');
    }
  }
};
</script>

<style></style>
